import React, { useEffect, useRef, useState } from "react";
import { globalLoader, handleOffcanvasScroll, handleServerValidations } from "../../../../../utils/commonfunction";
import { getRestaurantSettings, UpdateEmailNotification } from "../../../services/profile.services";
import { LOADER_TIMEOUT_TIME, SWAL_SETTINGS } from "../../../../../utils/Constants";
import Swal from "sweetalert2";
import { getEmailList, addEmail, deleteEmail, editEmail } from "../../../services/mail-notification-setting.services";
import { useFormik } from "formik";
import { useValidationSchemas } from "../../../validator/validation";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import RecordNotFound from "../../../shared/recordNotFound";
import CustomPagination from "../../../../admin/common/custompagination";
import { useLocation, useParams } from "react-router-dom";
import TableLoader from "../../../../../utils/TableLoader";
import trash from "../../../../../assets/restaurant/images/trash.svg";

export default function MailNotificationSettings() {
  const [mailNotificationDetails, setMailNotificationDetails] = useState({});
  const { t } = useTranslation();
  const [detailsLoader, setDetailsLoader] = useState(true);
  const [refreshList, setRefreshList] = useState(true);

  useEffect(() => {
    setDetailsLoader(true);
    getRestaurantSettings()
      .then((response) => {
        setTimeout(() => {
          setDetailsLoader(false);
        }, LOADER_TIMEOUT_TIME);
        setMailNotificationDetails(response && response?.data ? response?.data : {});
      })
      .catch((error) => {
        setTimeout(() => {
          setDetailsLoader(false);
        }, LOADER_TIMEOUT_TIME);
        console.log("Error===>", error);
      });
  }, []);

  // console.log("setMailNotificationDetailssetMailNotificationDetails", mailNotificationDetails);
  const handleChangeMasterSettings = (data, action) => {
    UpdateEmailNotification(data)
      .then((response) => {
        Swal.fire({
          icon: "success",
          text: response.message,
          ...SWAL_SETTINGS,
        });
        let settingsData = { ...mailNotificationDetails };
        Object.assign(settingsData, data);
        setMailNotificationDetails(settingsData);
        if (!action) {
          setRefreshList(!refreshList);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          text: handleServerValidations(error),
          ...SWAL_SETTINGS,
        });
      });
  }
  const handelEmailNotificationToggle = (action, key) => {
    let data = {};
    // console.log("action", action);
    // return;
    // const action = e?.target?.checked ? true : false;
    data[key] = action;
    if (action) {
      handleChangeMasterSettings(data, action);
    } else {
      Swal.fire({
        title: t("restaurant.mail_notification_setting.msg_are_you_sure"),
        text: t("restaurant.mail_notification_setting.msg_are_you_sure_to_disable_master_setting"),
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#6c757d",
        cancelButtonColor: "#dc3545",
        confirmButtonText: t("restaurant.mail_notification_setting.btn_yes"),
        cancelButtonText: t("restaurant.mail_notification_setting.btn_cancel"),
        customClass: {
          popup: 'swal-restaurant',
          confirmButton: 'btn btn-secondary col',
          cancelButton: 'btn btn-danger col'
        },
      }).then((result) => {
        if (result.isConfirmed) {
          handleChangeMasterSettings(data, action);
        }
      });
    }
  };

  return (
    <main id="main-content">
      <div className="inner-container">
        <div className="page-header d-flex align-items-center">
          <h4 className="heading-title-text">{t("restaurant.mail_notification_setting.link_mail_notification_settings")}</h4>
        </div>
        {detailsLoader ? (
          <div className="row">
            <div className="col-md-6 mb-4">
              <Skeleton className="rounded-3" style={{ height: "96px", width: "100%" }} />
            </div>
            <div className="col-md-6 mb-4">
              <Skeleton className="rounded-3" style={{ height: "96px", width: "100%" }} />
            </div>
            <div className="col-md-6 mb-4">
              <Skeleton className="rounded-3" style={{ height: "96px", width: "100%" }} />
            </div>
            <div className="col-md-6 mb-4">
              <Skeleton className="rounded-3" style={{ height: "96px", width: "100%" }} />
            </div>
            <div className="col-md-6 mb-4">
              <Skeleton className="rounded-3" style={{ height: "96px", width: "100%" }} />
            </div>
          </div>
        ) : (
          <div className="row">
            <div className="col-lg-6 mb-4">
              <div className="card mail-notification-card" style={{ width: "100%" }}>
                <div className="card-body">
                  <div className="d-flex justify-content-between">
                    <div className="mail-card-left">
                      <h4>{t("restaurant.mail_notification_setting.mail_opening")}</h4>
                      <p>{t("restaurant.mail_notification_setting.opening_sales_text")}</p>
                    </div>
                    <div className="mai-card-right">
                      <div className="form-check form-switch e_none cp" onClick={() => { handelEmailNotificationToggle(!mailNotificationDetails?.openings_emails, "openings_emails") }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={mailNotificationDetails?.openings_emails}
                          onChange={() => { }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-4">
              <div className="card mail-notification-card" style={{ width: "100%" }}>
                <div className="card-body">
                  <div className="d-flex justify-content-between">
                    <div className="mail-card-left">
                      <h4>{t("restaurant.mail_notification_setting.mail_settlement")}</h4>
                      <p>{t("restaurant.mail_notification_setting.enable_mail_text_settlement")}</p>
                    </div>
                    <div className="mai-card-right">
                      <div className="form-check form-switch e_none cp" onClick={() => { handelEmailNotificationToggle(!mailNotificationDetails?.settlements_emails, "settlements_emails") }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={mailNotificationDetails?.settlements_emails}
                          onChange={() => { }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-4">
              <div className="card mail-notification-card" style={{ width: "100%" }}>
                <div className="card-body">
                  <div className="d-flex justify-content-between">
                    <div className="mail-card-left">
                      <h4>Delete Sales</h4>
                      <p>{t("restaurant.mail_notification_setting.cancel_sales_text")}</p>
                    </div>
                    <div className="mai-card-right">
                      <div className="form-check form-switch e_none cp" onClick={() => { handelEmailNotificationToggle(!mailNotificationDetails?.delete_sales_emails, "delete_sales_emails") }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={mailNotificationDetails?.delete_sales_emails}
                          onChange={() => { }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </main>
  );
}
